module.exports = __webpack_public_path__ + "static/media/github-friends.4e99e23d.png";